import * as types from '../mutation-types'
import api from '../api'

const getDefaultState = () => {
    return {
        headerInfoNotifications: {
            data: []
        },
        headerInfoRequestParams: {
            read: 0,
            per_page: 10,
            paginate: 1,
            type_group: 'information'
        },
        headerActionNotifications: {
            data: []
        },
        headerActionRequestParams: {
            read: 0,
            per_page: 10,
            paginate: 1,
            type_group: 'action'
        },
        viewNotifications: {
            data: []
        },
        viewRequestParams: {
            read: null,
            per_page: 25,
            paginate: 1,
            type_group: 'action',
            page: 1
        },

        manual_notifications: {
            data: []
        }
    }
}

const state = getDefaultState()

const mutations = {
    resetNotificationsState (state) {
        Object.assign(state, getDefaultState())
    },
    SET_HEADER_INFO_NOTIFICATIONS(state, payload) {
        state.headerInfoNotifications = payload
    },
    SET_HEADER_ACTION_NOTIFICATIONS(state, payload) {
        state.headerActionNotifications = payload
    },
    SET_VIEW_NOTIFICATIONS(state, payload) {
        state.viewNotifications = payload
    },
    SET_TYPE_GROUP_VIEW_PARAM(state, typeGroup) {
        state.viewRequestParams.type_group = typeGroup
    },
    SET_PAGE_VIEW_PARAM(state, page) {
        state.viewRequestParams.page = page
    },
    SET_READ_VIEW_PARAM(state, read) {
        state.viewRequestParams.read = read
    },

    [types.MANUAL_NOTIFICATIONS_RECEIVED](state, payload) {
        state.manual_notifications = payload
    }
}

const getUserParams = function(rootState, rootGetters) {
    const agencies = rootGetters.isAgency ? _.map(rootState.user.me.agencies, 'id') : []
    const user_groups = _.map(rootState.user.me.groups, 'id')

    return {agencies, user_groups}
}

const actions = {
    resetNotificationsState ({ commit }) {
        commit('resetNotificationsState')
    },

    fetchHeaderInfoNotifications({commit, state, rootState, rootGetters}) {
        let requestParams = state.headerInfoRequestParams
        
        Object.assign(requestParams, getUserParams(rootState, rootGetters))

        return api.getNotifications(requestParams)
            .then(response => commit('SET_HEADER_INFO_NOTIFICATIONS', response.data.notifications))
    },
    fetchHeaderActionNotifications({commit, state, rootState, rootGetters}) {
        let requestParams = state.headerActionRequestParams
        
        Object.assign(requestParams, getUserParams(rootState, rootGetters))

        return api.getNotifications(requestParams)
            .then(response => commit('SET_HEADER_ACTION_NOTIFICATIONS', response.data.notifications))
    },
    fetchViewNotifications({commit, state, rootState, rootGetters}) {
        const rootStateMe = rootState.user.me
        if (Object !== rootState.constructor || Object.keys(rootStateMe).length == 0) {
            return
        }
        
        let requestParams = state.viewRequestParams
        
        Object.assign(requestParams, getUserParams(rootState, rootGetters))

        return api.getNotifications(requestParams)
            .then(response => commit('SET_VIEW_NOTIFICATIONS', response.data.notifications))
    },
    updateTypeGroupForView({commit}, typeGroup) {
        commit('SET_TYPE_GROUP_VIEW_PARAM', typeGroup)
    },
    updatePageForView({commit}, page) {
        commit('SET_PAGE_VIEW_PARAM', page)
    },
    updateReadForView({commit}, read) {
        commit('SET_READ_VIEW_PARAM', read)
    },

    toggleReadAttribute({ commit }, notification) {
        if (notification.read_at == null) {
            return api.readNotification(notification.id)
        } else {
            return api.unreadNotification(notification.id)
        }
    },
    readNotification({ commit }, notification) {
      return api.readNotification(notification.id)
    },
    fetchManualNotifications({ commit }) {
        return api.getManualNotifications()
            .then(response => commit(types.MANUAL_NOTIFICATIONS_RECEIVED, response.data.manual_notifications))
    },

    sendManualNotification({ commit }, params) {
        return api.sendManualNotification(params)
    },

    fetchNotificationsOnBroadcast({commit, state, rootState, dispatch}, notification) {
        // Only when concerned 
        
        // 1. Viewing the list of notifications of the same type group
        if ('notifications' == rootState.route.name && state.viewRequestParams.type_group == notification.type_group) {
            dispatch('fetchViewNotifications')
        }
        // 2. Header notifications of the same type group
        if ('information' == notification.type_group) {
            dispatch('fetchHeaderInfoNotifications')
        } else if ('action' == notification.type_group) {
            dispatch('fetchHeaderActionNotifications')
        }
    }
}

const getters = {
    headerInfoNotifications (state) {
        return state.headerInfoNotifications
    },
    headerActionNotifications (state) {
        return state.headerActionNotifications
    },
    viewNotifications (state) {
        return state.viewNotifications
    },
    viewRequestParams (state) {
        return state.viewRequestParams
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./client/store/modules/notifications.js